const CheckAccountType = {
    CashierCheckAccount:"1747",
    POSCheckAccount:"1748"
}
export {CheckAccountType}